import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// users
import user1 from "../../../assets/images/avatar.png";
import { selectUser } from "store/features/auth/authSlice";
import { selectCurrentCRM } from "store/features/users/userSlice";

const ProfileMenu = props => {
  const user = useSelector(selectUser);
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [username, setusername] = useState("Admin");

  const currentCRM = useSelector(selectCurrentCRM);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  return (
    <React.Fragment>

      {
        currentCRM != "qwik_bistro" &&
        <Dropdown
          isOpen={menu}
          toggle={() => setMenu(!menu)}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item waves-effect"
            id="page-header-user-dropdown"
            tag="button"
          >
            <img
              className="rounded-circle header-profile-user"
              src={user?.image || user1}
              alt="Header Avatar"
            />

          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a" href="/profile">
              {" "}
              <i className="mdi mdi-account-circle font-size-17 align-middle me-1" />
              {props.t("Profile")}{" "}
            </DropdownItem>
            {/* <DropdownItem tag="a" href="#">
            {" "}
            <i className="mdi mdi-wallet font-size-17 align-middle me-1" />
            {props.t("My Wallet")}{" "}
          </DropdownItem> */}
            {/* <DropdownItem tag="a" href="#">
            {" "}
            <i className="mdi mdi-cog font-size-17 align-middle me-1" />
            {props.t("Settings")}{" "}
            <span className="badge bg-success ms-auto">11</span>
          </DropdownItem> */}
            {/* <DropdownItem tag="a" href="auth-lock-screen">
            <i className="mdi mdi-lock-open-outline font-size-17 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem> */}
            <div className="dropdown-divider" />
            <Link to="/logout" className="dropdown-item text-danger">
              <i className="bx bx-power-off font-size-17 align-middle me-1 text-danger" />
              <span>{props.t("Logout")}</span>
            </Link>
          </DropdownMenu>
        </Dropdown>

      }

    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
